"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const ApplicationContext_1 = __importDefault(require("../../../PageBooter/ApplicationContext"));
const style_1 = __importDefault(require("./style"));
const BottomMenuSheetWrapperRenderer = ({ page, children, }) => {
    var _a, _b, _c, _d;
    const { bottomMenuContext } = (0, react_1.useContext)(ApplicationContext_1.default);
    const { Render, functions: { processor } } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const isBottomMenuClosed = !((_a = page.bottomMenuSheet) === null || _a === void 0 ? void 0 : _a.active) || !(bottomMenuContext === null || bottomMenuContext === void 0 ? void 0 : bottomMenuContext[page.id]);
    if (isBottomMenuClosed) {
        return null;
    }
    const contentHeight = (_d = (_c = (_b = page.bottomMenuSheet.style) === null || _b === void 0 ? void 0 : _b.height) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : 80;
    const shadowAreaHeight = 100 - contentHeight;
    return (react_1.default.createElement(Render.View, { style: style_1.default.wrapper },
        react_1.default.createElement(Render.TouchableOpacity, { style: Object.assign(Object.assign({}, style_1.default.shadowArea), { height: `${shadowAreaHeight}%` }), onPress: () => processor.root.setIsBottomMenuOpened(false) }),
        react_1.default.createElement(Render.View, { style: Object.assign(Object.assign({}, style_1.default.shadowArea), { height: `${contentHeight}%`, position: 'relative' }) }, children)));
};
exports.default = BottomMenuSheetWrapperRenderer;
